<p class="font-medium text-text-primary">
  <pxc-form-question-label mode="form" [question]="question()" />
</p>
<pxc-form-decoration position="before" [content]="question().decorations?.before" />

<pxc-form-question-input mode="form" [control]="control()" [question]="question()" [readOnly]="isReadOnly()" />

@if (question().modules.length) {
  <pxc-form-manual-trigger
    [moduleInputs]="moduleInputs()"
    [modules]="question().modules"
    [targetId]="question().id"
    (moduleReset)="moduleReset.emit($event)"
    (moduleTriggered)="moduleTriggered.emit($event)" />
}

@let showError = question().isVisited || control().touched || control().dirty;
@if (hasErrors() && showError) {
  <tui-error data-testid="error-display" [error]="question().errors[0].message" />
}
<pxc-form-decoration position="after" [content]="question().decorations?.after" />
